"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_ADDONS_RESET = exports.UPDATE_ADDONS_SUCCESS = exports.UPDATE_ADDONS_FAILURE = exports.UPDATE_ADDONS_REQUEST = exports.RESUME_PURCHASE_RESET = exports.RESUME_PURCHASE_LOGIN_SUCCESS = exports.RESUME_PURCHASE_LOGIN_FAILURE = exports.RESUME_PURCHASE_LOGIN_REQUEST = exports.SAVE_HOME_TO_USER_RESET = exports.SAVE_HOME_TO_USER_FAILURE = exports.SAVE_HOME_TO_USER_SUCCESS = exports.SAVE_HOME_TO_USER_REQUEST = exports.SAVE_LAST_SCREEN_FAILURE = exports.SAVE_LAST_SCREEN_SUCCESS = exports.SAVE_LAST_SCREEN_REQUEST = exports.RESET_SUBMIT_ORDER = exports.SUBMIT_ORDER_FAILURE = exports.SUBMIT_ORDER_SUCCESS = exports.SUBMIT_ORDER_REQUEST = exports.USER_START_SALE_FAILURE = exports.USER_START_SALE_SUCCESS = exports.USER_START_SALE_REQUEST = exports.UPDATE_WEBLEAD_DATA_FAILURE = exports.UPDATE_WEBLEAD_DATA_SUCCESS = exports.UPDATE_WEBLEAD_DATA_REQUEST = exports.RESET_USER_PRENEED_DETAILS_UPDATED = exports.UPDATE_USER_PRENEED_DETAILS_FAILURE = exports.UPDATE_USER_PRENEED_DETAILS_SUCCESS = exports.UPDATE_USER_PRENEED_DETAILS_REQUEST = exports.RESET_USER_BIRTHDAY_UPDATED = exports.UPDATE_USER_BIRTHDAY_FAILURE = exports.UPDATE_USER_BIRTHDAY_SUCCESS = exports.UPDATE_USER_BIRTHDAY_REQUEST = exports.RESET_PLAN_PACKAGE_UPDATED = exports.UPDATE_USER_PACKAGE_FAILURE = exports.UPDATE_USER_PACKAGE_SUCCESS = exports.UPDATE_USER_PACKAGE_REQUEST = exports.SAVE_PLAN_TO_USER_FAILURE = exports.SAVE_PLAN_TO_USER_SUCCESS = exports.SAVE_PLAN_TO_USER_REQUEST = exports.SAVE_PACKAGE_TO_USER_FAILURE = exports.SAVE_PACKAGE_TO_USER_SUCCESS = exports.SAVE_PACKAGE_TO_USER_REQUEST = exports.RESET_CREATE_NEW_PRENEED_USER = exports.CREATE_NEW_PRENEED_USER_FAILURE = exports.CREATE_NEW_PRENEED_USER_SUCCESS = exports.CREATE_NEW_PRENEED_USER_REQUEST = exports.EDIT_USER_SUCCESS = exports.RESET_SELECTED_PLAN = exports.RESET_SELECTED_PACKAGE = exports.RESET_WEBLEAD_UPDATED = exports.RESET_ERROR = exports.RESET_META = exports.V2_EDIT_USER_PROFILE_REQUEST = exports.V2_EDIT_USER_PROFILE_FAILURE = exports.V2_EDIT_USER_PROFILE_SUCCESS = exports.SAVE_USER_PHONE_FAILURE = exports.SAVE_USER_PHONE_SUCCESS = exports.SAVE_USER_PHONE_REQUEST = exports.V2_LOGIN_FAILURE = exports.V2_LOGIN_SUCCESS = exports.V2_LOGIN_REQUEST = exports.V2_CONFIRM_USER_FAILURE = exports.V2_CONFIRM_USER_SUCCESS = exports.V2_CONFIRM_USER_REQUEST = exports.V2_SHELL_LOGIN_FAILURE = exports.V2_SHELL_LOGIN_SUCCESS = exports.V2_SHELL_LOGIN_REQUEST = exports.VERIFY_PIN_FAILURE = exports.VERIFY_PIN_SUCCESS = exports.VERIFY_PIN_REQUEST = exports.SEND_PIN_AND_CALL_FAILURE = exports.SEND_PIN_AND_CALL_SUCCESS = exports.SEND_PIN_AND_CALL_REQUEST = exports.SEND_PIN_FAILURE = exports.SEND_PIN_SUCCESS = exports.SEND_PIN_REQUEST = exports.EDIT_USER_BY_ID_FAILURE = exports.EDIT_USER_BY_ID_SUCCESS = exports.EDIT_USER_BY_ID_REQUEST = exports.ID_LOGIN_FAILURE = exports.ID_LOGIN_SUCCESS = exports.ID_LOGIN_REQUEST = exports.DASH_LOGIN_FAILURE = exports.DASH_LOGIN_SUCCESS = exports.DASH_LOGIN_REQUEST = void 0;
// Dash Login
var DASH_LOGIN_REQUEST = 'DASH_LOGIN_REQUEST';
exports.DASH_LOGIN_REQUEST = DASH_LOGIN_REQUEST;
var DASH_LOGIN_SUCCESS = 'DASH_LOGIN_SUCCESS';
exports.DASH_LOGIN_SUCCESS = DASH_LOGIN_SUCCESS;
var DASH_LOGIN_FAILURE = 'DASH_LOGIN_FAILURE'; // Invited share page login

exports.DASH_LOGIN_FAILURE = DASH_LOGIN_FAILURE;
var ID_LOGIN_REQUEST = 'ID_LOGIN_REQUEST';
exports.ID_LOGIN_REQUEST = ID_LOGIN_REQUEST;
var ID_LOGIN_SUCCESS = 'ID_LOGIN_SUCCESS';
exports.ID_LOGIN_SUCCESS = ID_LOGIN_SUCCESS;
var ID_LOGIN_FAILURE = 'ID_LOGIN_FAILURE';
exports.ID_LOGIN_FAILURE = ID_LOGIN_FAILURE;
var EDIT_USER_BY_ID_REQUEST = 'EDIT_USER_BY_ID_REQUEST';
exports.EDIT_USER_BY_ID_REQUEST = EDIT_USER_BY_ID_REQUEST;
var EDIT_USER_BY_ID_SUCCESS = 'EDIT_USER_BY_ID_SUCCESS';
exports.EDIT_USER_BY_ID_SUCCESS = EDIT_USER_BY_ID_SUCCESS;
var EDIT_USER_BY_ID_FAILURE = 'EDIT_USER_BY_ID_FAILURE'; // V2 Login

exports.EDIT_USER_BY_ID_FAILURE = EDIT_USER_BY_ID_FAILURE;
var SEND_PIN_REQUEST = 'SEND_PIN_REQUEST';
exports.SEND_PIN_REQUEST = SEND_PIN_REQUEST;
var SEND_PIN_SUCCESS = 'SEND_PIN_SUCCESS';
exports.SEND_PIN_SUCCESS = SEND_PIN_SUCCESS;
var SEND_PIN_FAILURE = 'SEND_PIN_FAILURE';
exports.SEND_PIN_FAILURE = SEND_PIN_FAILURE;
var SEND_PIN_AND_CALL_REQUEST = 'SEND_PIN_AND_CALL_REQUEST';
exports.SEND_PIN_AND_CALL_REQUEST = SEND_PIN_AND_CALL_REQUEST;
var SEND_PIN_AND_CALL_SUCCESS = 'SEND_PIN_AND_CALL_SUCCESS';
exports.SEND_PIN_AND_CALL_SUCCESS = SEND_PIN_AND_CALL_SUCCESS;
var SEND_PIN_AND_CALL_FAILURE = 'SEND_PIN_AND_CALL_FAILURE';
exports.SEND_PIN_AND_CALL_FAILURE = SEND_PIN_AND_CALL_FAILURE;
var VERIFY_PIN_REQUEST = 'VERIFY_PIN_REQUEST';
exports.VERIFY_PIN_REQUEST = VERIFY_PIN_REQUEST;
var VERIFY_PIN_SUCCESS = 'VERIFY_PIN_SUCCESS';
exports.VERIFY_PIN_SUCCESS = VERIFY_PIN_SUCCESS;
var VERIFY_PIN_FAILURE = 'VERIFY_PIN_FAILURE';
exports.VERIFY_PIN_FAILURE = VERIFY_PIN_FAILURE;
var V2_SHELL_LOGIN_REQUEST = 'V2_SHELL_LOGIN_REQUEST';
exports.V2_SHELL_LOGIN_REQUEST = V2_SHELL_LOGIN_REQUEST;
var V2_SHELL_LOGIN_SUCCESS = 'V2_SHELL_LOGIN_SUCCESS';
exports.V2_SHELL_LOGIN_SUCCESS = V2_SHELL_LOGIN_SUCCESS;
var V2_SHELL_LOGIN_FAILURE = 'V2_SHELL_LOGIN_FAILURE';
exports.V2_SHELL_LOGIN_FAILURE = V2_SHELL_LOGIN_FAILURE;
var V2_CONFIRM_USER_REQUEST = 'V2_CONFIRM_USER_REQUEST';
exports.V2_CONFIRM_USER_REQUEST = V2_CONFIRM_USER_REQUEST;
var V2_CONFIRM_USER_SUCCESS = 'V2_CONFIRM_USER_SUCCESS';
exports.V2_CONFIRM_USER_SUCCESS = V2_CONFIRM_USER_SUCCESS;
var V2_CONFIRM_USER_FAILURE = 'V2_CONFIRM_USER_FAILURE';
exports.V2_CONFIRM_USER_FAILURE = V2_CONFIRM_USER_FAILURE;
var V2_LOGIN_REQUEST = 'V2_LOGIN_REQUEST';
exports.V2_LOGIN_REQUEST = V2_LOGIN_REQUEST;
var V2_LOGIN_SUCCESS = 'V2_LOGIN_SUCCESS';
exports.V2_LOGIN_SUCCESS = V2_LOGIN_SUCCESS;
var V2_LOGIN_FAILURE = 'V2_LOGIN_FAILURE';
exports.V2_LOGIN_FAILURE = V2_LOGIN_FAILURE;
var SAVE_USER_PHONE_REQUEST = 'SAVE_USER_PHONE_REQUEST';
exports.SAVE_USER_PHONE_REQUEST = SAVE_USER_PHONE_REQUEST;
var SAVE_USER_PHONE_SUCCESS = 'SAVE_USER_PHONE_SUCCESS';
exports.SAVE_USER_PHONE_SUCCESS = SAVE_USER_PHONE_SUCCESS;
var SAVE_USER_PHONE_FAILURE = 'SAVE_USER_PHONE_FAILURE'; // Profile Page Edit User

exports.SAVE_USER_PHONE_FAILURE = SAVE_USER_PHONE_FAILURE;
var V2_EDIT_USER_PROFILE_SUCCESS = 'V2_EDIT_USER_PROFILE_SUCCESS';
exports.V2_EDIT_USER_PROFILE_SUCCESS = V2_EDIT_USER_PROFILE_SUCCESS;
var V2_EDIT_USER_PROFILE_FAILURE = 'V2_EDIT_USER_PROFILE_FAILURE';
exports.V2_EDIT_USER_PROFILE_FAILURE = V2_EDIT_USER_PROFILE_FAILURE;
var V2_EDIT_USER_PROFILE_REQUEST = 'V2_EDIT_USER_PROFILE_REQUEST'; // Reset

exports.V2_EDIT_USER_PROFILE_REQUEST = V2_EDIT_USER_PROFILE_REQUEST;
var RESET_META = 'RESET_META';
exports.RESET_META = RESET_META;
var RESET_ERROR = 'RESET_ERROR';
exports.RESET_ERROR = RESET_ERROR;
var RESET_WEBLEAD_UPDATED = 'RESET_WEBLEAD_UPDATED';
exports.RESET_WEBLEAD_UPDATED = RESET_WEBLEAD_UPDATED;
var RESET_SELECTED_PACKAGE = 'RESET_SELECTED_PACKAGE';
exports.RESET_SELECTED_PACKAGE = RESET_SELECTED_PACKAGE;
var RESET_SELECTED_PLAN = 'RESET_SELECTED_PLAN'; // Demo Mode

exports.RESET_SELECTED_PLAN = RESET_SELECTED_PLAN;
var EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
/** Purchase Flow */
// create a new preneed user

exports.EDIT_USER_SUCCESS = EDIT_USER_SUCCESS;
var CREATE_NEW_PRENEED_USER_REQUEST = 'CREATE_NEW_PRENEED_USER_REQUEST';
exports.CREATE_NEW_PRENEED_USER_REQUEST = CREATE_NEW_PRENEED_USER_REQUEST;
var CREATE_NEW_PRENEED_USER_SUCCESS = 'CREATE_NEW_PRENEED_USER_SUCCESS';
exports.CREATE_NEW_PRENEED_USER_SUCCESS = CREATE_NEW_PRENEED_USER_SUCCESS;
var CREATE_NEW_PRENEED_USER_FAILURE = 'CREATE_NEW_PRENEED_USER_FAILURE';
exports.CREATE_NEW_PRENEED_USER_FAILURE = CREATE_NEW_PRENEED_USER_FAILURE;
var RESET_CREATE_NEW_PRENEED_USER = 'RESET_CREATE_NEW_PRENEED_USER'; // Save selected package

exports.RESET_CREATE_NEW_PRENEED_USER = RESET_CREATE_NEW_PRENEED_USER;
var SAVE_PACKAGE_TO_USER_REQUEST = 'SAVE_PACKAGE_TO_USER_REQUEST';
exports.SAVE_PACKAGE_TO_USER_REQUEST = SAVE_PACKAGE_TO_USER_REQUEST;
var SAVE_PACKAGE_TO_USER_SUCCESS = 'SAVE_PACKAGE_TO_USER_SUCCESS';
exports.SAVE_PACKAGE_TO_USER_SUCCESS = SAVE_PACKAGE_TO_USER_SUCCESS;
var SAVE_PACKAGE_TO_USER_FAILURE = 'SAVE_PACKAGE_TO_USER_FAILURE'; // Save selected plan

exports.SAVE_PACKAGE_TO_USER_FAILURE = SAVE_PACKAGE_TO_USER_FAILURE;
var SAVE_PLAN_TO_USER_REQUEST = 'SAVE_PLAN_TO_USER_REQUEST';
exports.SAVE_PLAN_TO_USER_REQUEST = SAVE_PLAN_TO_USER_REQUEST;
var SAVE_PLAN_TO_USER_SUCCESS = 'SAVE_PLAN_TO_USER_SUCCESS';
exports.SAVE_PLAN_TO_USER_SUCCESS = SAVE_PLAN_TO_USER_SUCCESS;
var SAVE_PLAN_TO_USER_FAILURE = 'SAVE_PLAN_TO_USER_FAILURE'; // update package and terms on user

exports.SAVE_PLAN_TO_USER_FAILURE = SAVE_PLAN_TO_USER_FAILURE;
var UPDATE_USER_PACKAGE_REQUEST = 'UPDATE_USER_PACKAGE_REQUEST';
exports.UPDATE_USER_PACKAGE_REQUEST = UPDATE_USER_PACKAGE_REQUEST;
var UPDATE_USER_PACKAGE_SUCCESS = 'UPDATE_USER_PACKAGE_SUCCESS';
exports.UPDATE_USER_PACKAGE_SUCCESS = UPDATE_USER_PACKAGE_SUCCESS;
var UPDATE_USER_PACKAGE_FAILURE = 'UPDATE_USER_PACKAGE_FAILURE';
exports.UPDATE_USER_PACKAGE_FAILURE = UPDATE_USER_PACKAGE_FAILURE;
var RESET_PLAN_PACKAGE_UPDATED = 'RESET_PLAN_PACKAGE_UPDATED'; // update user birthday

exports.RESET_PLAN_PACKAGE_UPDATED = RESET_PLAN_PACKAGE_UPDATED;
var UPDATE_USER_BIRTHDAY_REQUEST = 'UPDATE_USER_BIRTHDAY_REQUEST';
exports.UPDATE_USER_BIRTHDAY_REQUEST = UPDATE_USER_BIRTHDAY_REQUEST;
var UPDATE_USER_BIRTHDAY_SUCCESS = 'UPDATE_USER_BIRTHDAY_SUCCESS';
exports.UPDATE_USER_BIRTHDAY_SUCCESS = UPDATE_USER_BIRTHDAY_SUCCESS;
var UPDATE_USER_BIRTHDAY_FAILURE = 'UPDATE_USER_BIRTHDAY_FAILURE';
exports.UPDATE_USER_BIRTHDAY_FAILURE = UPDATE_USER_BIRTHDAY_FAILURE;
var RESET_USER_BIRTHDAY_UPDATED = 'RESET_USER_BIRTHDAY_UPDATED'; // update user preneed details

exports.RESET_USER_BIRTHDAY_UPDATED = RESET_USER_BIRTHDAY_UPDATED;
var UPDATE_USER_PRENEED_DETAILS_REQUEST = 'UPDATE_USER_PRENEED_DETAILS_REQUEST';
exports.UPDATE_USER_PRENEED_DETAILS_REQUEST = UPDATE_USER_PRENEED_DETAILS_REQUEST;
var UPDATE_USER_PRENEED_DETAILS_SUCCESS = 'UPDATE_USER_PRENEED_DETAILS_SUCCESS';
exports.UPDATE_USER_PRENEED_DETAILS_SUCCESS = UPDATE_USER_PRENEED_DETAILS_SUCCESS;
var UPDATE_USER_PRENEED_DETAILS_FAILURE = 'UPDATE_USER_PRENEED_DETAILS_FAILURE';
exports.UPDATE_USER_PRENEED_DETAILS_FAILURE = UPDATE_USER_PRENEED_DETAILS_FAILURE;
var RESET_USER_PRENEED_DETAILS_UPDATED = 'RESET_USER_PRENEED_DETAILS_UPDATED'; // Update eFuneral data on user - okay to delete? - Marc 4.13.2021

exports.RESET_USER_PRENEED_DETAILS_UPDATED = RESET_USER_PRENEED_DETAILS_UPDATED;
var UPDATE_WEBLEAD_DATA_REQUEST = 'UPDATE_WEBLEAD_DATA_REQUEST';
exports.UPDATE_WEBLEAD_DATA_REQUEST = UPDATE_WEBLEAD_DATA_REQUEST;
var UPDATE_WEBLEAD_DATA_SUCCESS = 'UPDATE_WEBLEAD_DATA_SUCCESS';
exports.UPDATE_WEBLEAD_DATA_SUCCESS = UPDATE_WEBLEAD_DATA_SUCCESS;
var UPDATE_WEBLEAD_DATA_FAILURE = 'UPDATE_WEBLEAD_DATA_FAILURE'; // Start sale

exports.UPDATE_WEBLEAD_DATA_FAILURE = UPDATE_WEBLEAD_DATA_FAILURE;
var USER_START_SALE_REQUEST = 'USER_START_SALE_REQUEST';
exports.USER_START_SALE_REQUEST = USER_START_SALE_REQUEST;
var USER_START_SALE_SUCCESS = 'USER_START_SALE_SUCCESS';
exports.USER_START_SALE_SUCCESS = USER_START_SALE_SUCCESS;
var USER_START_SALE_FAILURE = 'USER_START_SALE_FAILURE'; // Submit order

exports.USER_START_SALE_FAILURE = USER_START_SALE_FAILURE;
var SUBMIT_ORDER_REQUEST = 'SUBMIT_ORDER_REQUEST';
exports.SUBMIT_ORDER_REQUEST = SUBMIT_ORDER_REQUEST;
var SUBMIT_ORDER_SUCCESS = 'SUBMIT_ORDER_SUCCESS';
exports.SUBMIT_ORDER_SUCCESS = SUBMIT_ORDER_SUCCESS;
var SUBMIT_ORDER_FAILURE = 'SUBMIT_ORDER_FAILURE';
exports.SUBMIT_ORDER_FAILURE = SUBMIT_ORDER_FAILURE;
var RESET_SUBMIT_ORDER = 'RESET_SUBMIT_ORDER'; // LastScreen

exports.RESET_SUBMIT_ORDER = RESET_SUBMIT_ORDER;
var SAVE_LAST_SCREEN_REQUEST = 'SAVE_LAST_SCREEN_REQUEST';
exports.SAVE_LAST_SCREEN_REQUEST = SAVE_LAST_SCREEN_REQUEST;
var SAVE_LAST_SCREEN_SUCCESS = 'SAVE_LAST_SCREEN_SUCCESS';
exports.SAVE_LAST_SCREEN_SUCCESS = SAVE_LAST_SCREEN_SUCCESS;
var SAVE_LAST_SCREEN_FAILURE = 'SAVE_LAST_SCREEN_FAILURE'; // Save funeralHome

exports.SAVE_LAST_SCREEN_FAILURE = SAVE_LAST_SCREEN_FAILURE;
var SAVE_HOME_TO_USER_REQUEST = 'SAVE_HOME_TO_USER_REQUEST';
exports.SAVE_HOME_TO_USER_REQUEST = SAVE_HOME_TO_USER_REQUEST;
var SAVE_HOME_TO_USER_SUCCESS = 'SAVE_HOME_TO_USER_SUCCESS';
exports.SAVE_HOME_TO_USER_SUCCESS = SAVE_HOME_TO_USER_SUCCESS;
var SAVE_HOME_TO_USER_FAILURE = 'SAVE_HOME_TO_USER_FAILURE';
exports.SAVE_HOME_TO_USER_FAILURE = SAVE_HOME_TO_USER_FAILURE;
var SAVE_HOME_TO_USER_RESET = 'SAVE_HOME_TO_USER_RESET'; // Resume Purchase

exports.SAVE_HOME_TO_USER_RESET = SAVE_HOME_TO_USER_RESET;
var RESUME_PURCHASE_LOGIN_REQUEST = 'RESUME_PURCHASE_LOGIN_REQUEST';
exports.RESUME_PURCHASE_LOGIN_REQUEST = RESUME_PURCHASE_LOGIN_REQUEST;
var RESUME_PURCHASE_LOGIN_FAILURE = 'RESUME_PURCHASE_LOGIN_FAILURE';
exports.RESUME_PURCHASE_LOGIN_FAILURE = RESUME_PURCHASE_LOGIN_FAILURE;
var RESUME_PURCHASE_LOGIN_SUCCESS = 'RESUME_PURCHASE_LOGIN_SUCCESS';
exports.RESUME_PURCHASE_LOGIN_SUCCESS = RESUME_PURCHASE_LOGIN_SUCCESS;
var RESUME_PURCHASE_RESET = 'RESUME_PURCHASE_RESET'; // Update AddOns

exports.RESUME_PURCHASE_RESET = RESUME_PURCHASE_RESET;
var UPDATE_ADDONS_REQUEST = 'UPDATE_ADDONS_REQUEST';
exports.UPDATE_ADDONS_REQUEST = UPDATE_ADDONS_REQUEST;
var UPDATE_ADDONS_FAILURE = 'UPDATE_ADDONS_FAILURE';
exports.UPDATE_ADDONS_FAILURE = UPDATE_ADDONS_FAILURE;
var UPDATE_ADDONS_SUCCESS = 'UPDATE_ADDONS_SUCCESS';
exports.UPDATE_ADDONS_SUCCESS = UPDATE_ADDONS_SUCCESS;
var UPDATE_ADDONS_RESET = 'UPDATE_ADDONS_RESET';
exports.UPDATE_ADDONS_RESET = UPDATE_ADDONS_RESET;